
/**
 * 
 * @returns UI for both roadmap page and blogs page card
 */
export default function HomeActionCards() {
  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-6 px-4 sm:flex-row">
      <ActionCard
        theme="purple"
        title="Low Level Design Roadmap"
        text="What to expect and how to present your solution during LLD rounds"
        buttonText="View Roadmap"
        href="/roadmap"
        icon={<RoadmapIcon />}
      />

      <ActionCard
        theme="orange"
        title="Blog"
        text="Latest insights, tips, and company specific articles for interview prep."
        buttonText="Read Blog"
        href="/blog"
        icon={<BlogIcon />}
      />
    </div>
  );
}

function ActionCard({ theme, title, text, buttonText, href, icon }) {
  const isPurple = theme === "purple";

  return (
    <a
      target="_blank"  
      href={href}
      className={`flex flex-1 items-center gap-6 rounded-2xl border p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-md ${
        isPurple
          ? "border-purple-200 bg-purple-50/40"
          : "border-orange-200 bg-orange-50/40"
      }`}
    >
      <div
        className={`flex h-24 w-24 shrink-0 items-center justify-center rounded-full ${
          isPurple ? "bg-purple-100 text-purple-600" : "bg-orange-100 text-orange-600"
        }`}
      >
        {icon}
      </div>

      <div>
        <h3 className="text-xl font-bold text-slate-900">{title}</h3>
        <p className="mt-2 max-w-xs text-sm leading-6 text-slate-600">{text}</p>

        <span
          className={`mt-4 inline-flex items-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold ${
            isPurple
              ? "bg-purple-600 text-white"
              : "border border-orange-500 text-orange-600"
          }`}
        >
          {buttonText}
          <span>→</span>
        </span>
      </div>
    </a>
  );
}

function RoadmapIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" fill="none">
      <path
        d="M12 34h10c5 0 5-8 0-8h-6c-5 0-5-8 0-8h18"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M34 10v12l8-6-8-6Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="34" r="4" stroke="currentColor" strokeWidth="4" />
    </svg>
  );
}

function BlogIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" fill="none">
      <path
        d="M14 10h20v28H14V10Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        d="M20 19h10M20 27h8"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M31 12l5-5 5 5-5 5"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinejoin="round"
      />
    </svg>
  );
}